import { useCallback } from "react";
import { ShellBridgeEvents } from "app/shared/constants/constants";
import useCustomEvent from "hooks/useCustomEvent";
import { publishShellEvent } from "utilities/publishBridgeEvent";

const WEB_NAV_BACK_EVENT = "web-navBack";

type ShellBackNavigationOptions = {
    isLandingPage?: boolean;
    isBlocked?: boolean;
    // Need to skip the back navigation if the cart is visible. It is different from blocked
    isSkipped?: boolean;
    nextRoute?: string;
    onBack?: ()=>void;
};

export default function useShellBackNavigation({
    isLandingPage = false,
    isBlocked = false,
    isSkipped = false,
    onBack,
}: ShellBackNavigationOptions) {
    const backCallback = useCallback(() => {
        if (isSkipped) {
            return;
        }
        if (isBlocked) {
            publishShellEvent(ShellBridgeEvents.MOBILE_NAV_CANCEL);
            return;
        }
        if (onBack) {
            onBack();
            return;
        }
        if (isLandingPage) {
            publishShellEvent(ShellBridgeEvents.MOBILE_NAV_POP);
        }
    }, [
        isBlocked,
        isLandingPage,
        isSkipped,
        onBack,
    ]);

    useCustomEvent(WEB_NAV_BACK_EVENT, backCallback);
}
